export default __webpack_public_path__ + "static/illustration-content.url-4301322a46f4687d921219a86703d985.svg";